import React from "react";
import { PickersTextField } from "@mui/x-date-pickers/PickersTextField";

/** When false, the in-progress quadrimester cannot be selected. */
export const ENABLE_CURRENT_QUADRIMESTER_SELECTION_FOR_TESTING = false;

export const snapshotDateFieldSx = {
  width: "100%",
  "& .MuiPickersOutlinedInput-root": {
    borderRadius: 0,
  },
  "& .MuiPickersInputBase-sectionsContainer": {
    padding: "8px 0",
    width: "auto",
    minWidth: 0,
    flexGrow: 1,
  },
  "& .MuiPickersOutlinedInput-notchedOutline": {
    borderColor: "#ccc",
  },
  "& .MuiPickersOutlinedInput-root:hover .MuiPickersOutlinedInput-notchedOutline": {
    borderColor: "#ccc !important",
  },
  "& .MuiPickersOutlinedInput-root.Mui-focused .MuiPickersOutlinedInput-notchedOutline": {
    borderColor: "#ccc !important",
    borderWidth: "1px !important",
  },
  "& .MuiIconButton-root:hover": {
    backgroundColor: "transparent",
    color: "rgba(0, 0, 0, 0.54)",
  },
};

const PERIOD_PLACEHOLDER = "Select reporting period...";

/**
 * Replaces the single-month field text with the quadrimester range label.
 * The picker still owns the calendar button through the forwarded field props.
 */
const QuadrimesterTextField = React.forwardRef(function QuadrimesterTextField(
  props: any,
  ref
) {
  const { periodLabel, elements, sx, ...other } = props;
  const fieldText = periodLabel || PERIOD_PLACEHOLDER;
  const displayElements =
    Array.isArray(elements) && elements.length > 0
      ? elements.map((element, index) => {
          if (index === 0) {
            return {
              ...element,
              content: { ...(element.content || {}), children: fieldText },
              after: { ...(element.after || {}), children: "" },
            };
          }
          return {
            ...element,
            before: { ...(element.before || {}), children: "" },
            content: { ...(element.content || {}), children: "" },
            after: { ...(element.after || {}), children: "" },
          };
        })
      : elements;

  return (
    <PickersTextField
      {...other}
      ref={ref}
      elements={displayElements}
      sx={[
        sx,
        {
          "& .MuiPickersInputBase-sectionsContainer": {
            caretColor: "transparent",
            cursor: "default",
            userSelect: "none",
          },
        },
        !periodLabel && {
          "& .MuiPickersInputBase-sectionsContainer": {
            opacity: "1 !important",
            color: "rgba(0, 0, 0, 0.42)",
          },
        },
      ]}
    />
  );
});

export default QuadrimesterTextField;
